var map = {
	"./ClientUploaded.svg": "./src/assets/icons/ClientUploaded.svg",
	"./ConfirmationsAddressees.svg": "./src/assets/icons/ConfirmationsAddressees.svg",
	"./ConfirmationsStamping.svg": "./src/assets/icons/ConfirmationsStamping.svg",
	"./Duesoon.svg": "./src/assets/icons/Duesoon.svg",
	"./Email.svg": "./src/assets/icons/Email.svg",
	"./Home – Workspace.svg": "./src/assets/icons/Home – Workspace.svg",
	"./MattersSolution.svg": "./src/assets/icons/MattersSolution.svg",
	"./Mobile.svg": "./src/assets/icons/Mobile.svg",
	"./Overdued.svg": "./src/assets/icons/Overdued.svg",
	"./RevisionRequired.svg": "./src/assets/icons/RevisionRequired.svg",
	"./Setting_clientRoles.svg": "./src/assets/icons/Setting_clientRoles.svg",
	"./Setting_clientUsers.svg": "./src/assets/icons/Setting_clientUsers.svg",
	"./Setting_general.svg": "./src/assets/icons/Setting_general.svg",
	"./Setting_groupReportingRole.svg": "./src/assets/icons/Setting_groupReportingRole.svg",
	"./Setting_groupReportingUser.svg": "./src/assets/icons/Setting_groupReportingUser.svg",
	"./Setting_kpUserRole.svg": "./src/assets/icons/Setting_kpUserRole.svg",
	"./Setting_kpmgTeamMember.svg": "./src/assets/icons/Setting_kpmgTeamMember.svg",
	"./arrow-right.svg": "./src/assets/icons/arrow-right.svg",
	"./arrow-right1.svg": "./src/assets/icons/arrow-right1.svg",
	"./bill.svg": "./src/assets/icons/bill.svg",
	"./dashboard-insights.svg": "./src/assets/icons/dashboard-insights.svg",
	"./file-doc.svg": "./src/assets/icons/file-doc.svg",
	"./file-docx.svg": "./src/assets/icons/file-docx.svg",
	"./file-msg.svg": "./src/assets/icons/file-msg.svg",
	"./file-pdf.svg": "./src/assets/icons/file-pdf.svg",
	"./file-ppt.svg": "./src/assets/icons/file-ppt.svg",
	"./file-pptx.svg": "./src/assets/icons/file-pptx.svg",
	"./file-xls.svg": "./src/assets/icons/file-xls.svg",
	"./file-xlsx.svg": "./src/assets/icons/file-xlsx.svg",
	"./home-overdue.svg": "./src/assets/icons/home-overdue.svg",
	"./home-regulatory.svg": "./src/assets/icons/home-regulatory.svg",
	"./home-soon.svg": "./src/assets/icons/home-soon.svg",
	"./home-tech.svg": "./src/assets/icons/home-tech.svg",
	"./icon-CN.svg": "./src/assets/icons/icon-CN.svg",
	"./icon-EN.svg": "./src/assets/icons/icon-EN.svg",
	"./icon-Exit-fullscreen.svg": "./src/assets/icons/icon-Exit-fullscreen.svg",
	"./icon-FAQ.svg": "./src/assets/icons/icon-FAQ.svg",
	"./icon-fullscreen.svg": "./src/assets/icons/icon-fullscreen.svg",
	"./icon-guidance.svg": "./src/assets/icons/icon-guidance.svg",
	"./icon-kee-title.svg": "./src/assets/icons/icon-kee-title.svg",
	"./icon-less.svg": "./src/assets/icons/icon-less.svg",
	"./icon-more.svg": "./src/assets/icons/icon-more.svg",
	"./icon-notice.svg": "./src/assets/icons/icon-notice.svg",
	"./information.svg": "./src/assets/icons/information.svg",
	"./kpContact.svg": "./src/assets/icons/kpContact.svg",
	"./kpSpeed.svg": "./src/assets/icons/kpSpeed.svg",
	"./log_out.svg": "./src/assets/icons/log_out.svg",
	"./logo-kpmg.svg": "./src/assets/icons/logo-kpmg.svg",
	"./numberThree.svg": "./src/assets/icons/numberThree.svg",
	"./numberTwo.svg": "./src/assets/icons/numberTwo.svg",
	"./pdf.svg": "./src/assets/icons/pdf.svg",
	"./qr-code.svg": "./src/assets/icons/qr-code.svg",
	"./status_CANCELLED.svg": "./src/assets/icons/status_CANCELLED.svg",
	"./status_FULLY PAID.svg": "./src/assets/icons/status_FULLY PAID.svg",
	"./status_NOT PAID.svg": "./src/assets/icons/status_NOT PAID.svg",
	"./status_PARTIALLY PAID.svg": "./src/assets/icons/status_PARTIALLY PAID.svg",
	"./user-email.svg": "./src/assets/icons/user-email.svg",
	"./user-phone.svg": "./src/assets/icons/user-phone.svg",
	"./user-position.svg": "./src/assets/icons/user-position.svg",
	"./user-usename.svg": "./src/assets/icons/user-usename.svg",
	"./xml.svg": "./src/assets/icons/xml.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/icons sync \\.svg$";